import LifeAgeInput from "./models/LifeAgeInput"
import LifeAgeResults from "./models/LifeAgeResults"
import LifeAgeScore from "./models/LifeAgeScore"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getResults = () => ObservableFromFetch<LifeAgeResults>("LifeAge/Results")
export const calculate = (params: LifeAgeInput) => ObservableFromFetch<LifeAgeScore>("LifeAge/Calculate", JSON.stringify(params))
